const niveisDeEstoque = {
  data: () => ({
    niveisDeEstoque: {
      excesso: 'EXCESSO',
      adequado: 'ADEQUADO',
      baixa_exp_ruptura: 'BAIXA EXPOSIÇÃO A RUPTURA',
      elevada_exp_ruptura: 'ELEVADA EXPOSIÇÃO A RUPTURA',
      ruptura: 'RUPTURA',
    }
  })
}


export default niveisDeEstoque
